type MobiusConfig = {
  [school: string]: {
    [program: string]: {
      apiKey: string;
      domain: string;
    };
  };
};

export const mobiusConfig: MobiusConfig = {
  den: {
    sw: {
      apiKey: "f429cace-198d-41f5-931f-0a0b9c33eee0",
      domain: ".du.edu",
    },
  },
  gu: {
    nursing: {
      apiKey: "cfca1805-08ba-4e38-90bc-33dcdfebc405",
      domain: ".georgetown.edu",
    },
    "nursing-agacnp": {
      apiKey: "cfca1805-08ba-4e38-90bc-33dcdfebc405",
      domain: ".georgetown.edu",
    },
    "nursing-fnp": {
      apiKey: "cfca1805-08ba-4e38-90bc-33dcdfebc405",
      domain: ".georgetown.edu",
    },
    "nursing-nmwhnp": {
      apiKey: "cfca1805-08ba-4e38-90bc-33dcdfebc405",
      domain: ".georgetown.edu",
    },
  },
  nu: {
    counseling: {
      apiKey: "254f4ce3-1082-46bd-b4da-c6b8f8a28703",
      domain: ".northwestern.edu",
    },
    "counseling-mac": {
      apiKey: "254f4ce3-1082-46bd-b4da-c6b8f8a28703",
      domain: ".northwestern.edu",
    },
    mft: {
      apiKey: "254f4ce3-1082-46bd-b4da-c6b8f8a28703",
      domain: ".northwestern.edu",
    },
  },
  pep: {
    map: {
      apiKey: "35ae7cd3-cf18-494f-9ab8-e6d67f65c879",
      domain: ".pepperdine.edu",
    },
    "map-aba-lpc": {
      apiKey: "35ae7cd3-cf18-494f-9ab8-e6d67f65c879",
      domain: ".pepperdine.edu",
    },
    "map-aba-lpc-lmft": {
      apiKey: "35ae7cd3-cf18-494f-9ab8-e6d67f65c879",
      domain: ".pepperdine.edu",
    },
  },
  rice: {
    mba: {
      apiKey: "5c8ead22-4c03-474a-9926-b254c456beb6",
      domain: ".rice.edu",
    },
  },
  ucb: {
    data: {
      apiKey: "ece9cb8b-32fd-49c4-9720-dc8ef891452f",
      domain: ".berkeley.edu",
    },
    cybersecurity: {
      apiKey: "33410c54-a3de-40e5-9a22-163c888f6818",
      domain: ".berkeley.edu",
    },
  },
  ucd: {
    mba: {
      apiKey: "72712460-5e8f-46ba-bb64-939dbf1d00bd",
      domain: ".ucdavis.edu",
    },
  },
  unc: {
    mba: {
      apiKey: "52ed2817-cfa9-4960-9ba0-24b2893b4011",
      domain: ".unc.edu",
    },
  },
};
